import type { CustomAttribute } from '@/types';
import type { PaginateAttributes } from '@/ui/LoadMore';
import { LoadMore } from '@/ui/LoadMore/LoadMore';

import NumberedPagination from './NumberedPagination';

interface PaginationProps {
  type: 'loadMore' | 'infiniteScroll' | 'numberedPagination';
  onLoadMore?: () => void;
  attributes: PaginateAttributes;
  customAttributes?: CustomAttribute;
  isBusy?: boolean;
  isLive?: boolean;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
  getPageHref?: (page: number) => string;
  nextPageHref?: string;
  nodeId?: string;
}

const Pagination = ({
  type,
  onLoadMore,
  attributes,
  isLive = false,
  isBusy = false,
  customAttributes,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  getPageHref,
  nextPageHref,
  nodeId,
}: PaginationProps) => {
  switch (type) {
    case 'loadMore':
    case 'infiniteScroll':
      return (
        <LoadMore
          onClick={onLoadMore!}
          attributes={attributes}
          isBusy={isBusy}
          isLive={isLive}
          customAttributes={customAttributes}
          nextPageHref={nextPageHref}
          nodeId={nodeId}
        />
      );
    case 'numberedPagination':
      return (
        <NumberedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange!}
          attributes={attributes}
          customAttributes={customAttributes}
          isLive={isLive}
          getPageHref={getPageHref}
        />
      );
  }
};

export default Pagination;
